// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__5c9W1","placeholderContainer":"styles_placeholderContainer__3kY9N"};